import React, { ReactNode } from 'react'
import styled from 'styled-components'
import { screen } from '@tumelo/designsystem'
import { PageWrapper } from '@/components/PageWrapper'
import { ColorTheme, Footer } from '../Footer'
import { ProfileHeader } from '../ProfileHeader'

export { DirectOutreachLayoutBasic } from './DirectOutreachLayoutBasic'

interface LayoutBasicProps {
  header?: ReactNode
  withMaxWidth?: boolean
  colorTheme?: ColorTheme
  disablePrivacyPolicy?: boolean
  disableTermsAndConditions?: boolean
}

interface LayoutContentOverHeaderProps {
  pageH1: string
  withMaxWidth?: boolean
}

export const LayoutBasic: React.FC<React.PropsWithChildren<LayoutBasicProps>> = ({
  children,
  header,
  withMaxWidth = true,
  disablePrivacyPolicy = false,
  disableTermsAndConditions = false,
}) => {
  return (
    <FlexPageContainer $colorTheme="light">
      {header}
      <PageWrapper withMaxWidth={withMaxWidth}>{children}</PageWrapper>
      <Footer
        colorTheme="light"
        disablePrivacyPolicy={disablePrivacyPolicy}
        disableTermsAndConditions={disableTermsAndConditions}
      />
    </FlexPageContainer>
  )
}

export const LayoutAuth: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <FlexPageContainer $colorTheme="dark">
      <main>{children}</main>
      <Footer colorTheme="dark" />
    </FlexPageContainer>
  )
}

export const LayoutContentOverHeader: React.FC<React.PropsWithChildren<LayoutContentOverHeaderProps>> = ({
  children,
  pageH1,
  withMaxWidth = true,
}) => {
  return (
    <FlexPageContainer>
      <ProfileHeader pageH1={pageH1} />
      <PageWrapper withMaxWidth={withMaxWidth}>
        <StyledContainerForHeader>{children}</StyledContainerForHeader>
      </PageWrapper>
      <Footer colorTheme="light" />
    </FlexPageContainer>
  )
}

const FlexPageContainer = styled.div<{ $colorTheme?: ColorTheme }>`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: ${({ $colorTheme, theme }) =>
    $colorTheme === 'dark' ? theme.colors.background.dark : theme.colors.background.medium};

  main {
    flex: 1;
  }
`

const StyledContainerForHeader = styled.div`
  margin-top: -5.2rem;

  @media ${screen.smallUp} {
    margin-top: -6.4rem;
  }

  @media ${screen.mediumUp} {
    margin-top: -8rem;
  }

  @media ${screen.largeUp} {
    margin-top: -10.8rem;
  }
`
